import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { BulkAdDaypartingUpdate } from "../../../zodios/apiDefinitions/api/ads";
import { errorToast, successToast } from "utils/toasts";

export function useBulkUpdateDayparting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: BulkAdDaypartingUpdate) => {
      await apiClient.updateDayparting(vars);
    },
    onSuccess: (data, vars) => {
      successToast({ message: `Media Plan${vars.advertisement_ids.length > 1 ? "s" : ""} Updated` });
      // TODO: shouldn't invalidate _all_ queries
      void queryClient.invalidateQueries();
    },
    onError: (error, vars) => {
      errorToast({ message: `Failed to update Media Plan${vars.advertisement_ids.length === 1 ? "" : "s"}`, error });
    },
  });
}
